var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "reset-password",
    attrs: {
      "title": $t("ai7i2u4", "修改密码"),
      "mask-closable": false,
      "width": "550"
    },
    on: {
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "register_column_item"
  }, [_vm.showRadio ? _c('Form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "required": "",
      "label": $t("k2pbsb4", "验证方式")
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.accoutTypeChange
    },
    model: {
      value: _vm.accountType,
      callback: function ($$v) {
        _vm.accountType = $$v;
      },
      expression: "accountType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "MOBILE"
    }
  }, [_c('span', [_vm._v($t("ewbd43", "手机号"))])]), _c('Radio', {
    attrs: {
      "label": "EMAIL"
    }
  }, [_c('span', [_vm._v($t("padf2", "邮箱"))])])], 1)], 1)], 1) : _vm._e(), _vm.visible ? _c('SendMessage', {
    ref: "sendMessage",
    attrs: {
      "accountType": _vm.accountType,
      "mode": "FORGET_PASSWORD",
      "exist": true
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e(), _c('Form', {
    staticClass: "password",
    attrs: {
      "model": _vm.form,
      "label-position": "top",
      "rules": _vm.rules
    }
  }, [_c('password-input', {
    ref: "form",
    model: {
      value: _vm.form.pw,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pw", $$v);
      },
      expression: "form.pw"
    }
  }), _c('div', {
    staticClass: "tip flex gap-2"
  }, [_c('Icon', {
    staticClass: "leading-[21px]",
    attrs: {
      "type": "md-alert"
    }
  }), _c('p', {
    staticClass: "max-w-[345px] text-left"
  }, [_vm._v(` ${$t("4tppx119", "密码要求（至少8位，包含大小写字母、数字、符号） 安全建议：避免使用生日、连续数字等弱密码")} `)])], 1)], 1)], 1)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };